export default __webpack_public_path__ + "images/man-off.a4f7d3941b4dba4d2c5d8cd6503fb684.png";